import React from 'react'
import RoomsFilter from './roomsFilter'
import RoomsList from './roomsList'
import {withRoomConsumer} from "../context";
import  Loading  from "./loading";

function RoomsContainer({context}) {
        const {loading, sortedRooms, rooms} = context

        if(loading){
            return <Loading />
        } 
        return(
            <>
                     <RoomsFilter  rooms={rooms} />
                     <RoomsList rooms={sortedRooms} />
            </>
        )
    }

export default withRoomConsumer(RoomsContainer)



// import React from 'react'
// import RoomsFilter from './roomsFilter'
// import RoomsList from './roomsList'
// import { RoomConsumer } from "../context";
// import  Loading  from "./loading";
// function RoomsContainer() {
//     return (
//         <RoomConsumer>
//             {
//               (value)=>{
//             //    console.log(value)
//                const {loading, sortedRooms, rooms} = value
//                if(loading){
//                    return <Loading />
//                }
//                return(
//                     <div>
//                         <h1>Yo room cont</h1>
//                         <RoomsFilter  rooms={rooms} />
//                         <RoomsList rooms={sortedRooms} />
//                     </div>
//                 )
//               }
//             }
//         </RoomConsumer>
//     )
// }

// export default RoomsContainer
